import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ContentChild,
  TemplateRef,
} from "@angular/core";
import { SelectItem, SortEvent } from "primeng/api";
import { Table } from "primeng/table";
import { Router, ActivatedRoute } from "@angular/router";
import { urlUpload, valorAnd, valorOr } from "src/app/config/config";
import { NgForOfContext } from "@angular/common";

@Component({
  selector: "app-simple-table",
  templateUrl: "./simple-table.component.html",
  styleUrls: ["./simple-table.component.css"],
})
export class SimpleTableComponent implements OnInit {
  @ViewChild("dt") dt: Table;

  @Input() cols: any;
  @Input() items: any;
  @Input() database: string;
  @Input() url2: string;
  @Input() urlCertificado: string;
  @Input() fieldsOkNok: any;
  @Input() camposOkNada: any;
  @Input() fieldsSi: any;
  @Input() botonesOfOn: any;
  @Input() revisionSalida: boolean;
  @Input() mostrarInformes: boolean;
  @Input() encuestaHigiene: boolean;
  @Input() mostrarOperarioAdd: boolean;
  @Input() showInfo: boolean;
  @Input() showDuplicate: boolean;
  @Input() listarTodos: boolean;
  @Input() certificado: boolean;
  @Input() discriminadorCampo: string;
  @Input() cuaderno_campo: boolean;
  @Input() showExportCsv: boolean;
  @Input() showAdd: boolean;
  @Input() filters: any[];
  @Input() filterActive: boolean = false;
  @Input() cellValueTransform!: (field: string, value: any) => any;

  @Output() consultarInformes: EventEmitter<any> = new EventEmitter<any>();
  @Output() listarCamposEmmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() listarCuadernodeCampo: EventEmitter<any> = new EventEmitter<any>();
  @Output() changeValueRevisionEmmit: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() changeValueEmmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() infoEmmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() iniciarEmmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() updateEmmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() deleteEmmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() duplicateEmmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() mostrarOperarioEmmit: EventEmitter<any> = new EventEmitter<any>();

  @ContentChild("header", { read: TemplateRef, static: false }) header:
    | TemplateRef<NgForOfContext<any, any>>
    | undefined;

  public oldValue: any;
  public selectedOpciones: string = "";
  public date2: Date;
  public text2: string;
  public es: any;
  public expression = false;

  public tiritas: any = [];
  public controlDataUpdate: any = [];
  public displayDialog = false;
  public displayMultiple = false;

  public editControl: any = [];
  public mostrar = false;
  public display: boolean = false;
  // public createTiritasForm:FormGroup;
  public myMonth = "";

  public tiritasInfo: any = [];
  public columnasVisibles: boolean = false;
  public anchoTabla = "1500px";

  public showTables = true;
  public first = 0;
  public mydt: any;

  public buscador: string = "";
  public auxitems: any[];
  public imageFile = urlUpload + "resource/file.png";
  public urlUploadArticulo = urlUpload + "/articulos/";
  public urlUploadPacks = urlUpload + "/sets/";

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.es = {
      firstDayOfWeek: 1,
      dayNames: [
        "domingo",
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado",
      ],
      dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
      dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
      monthNames: [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre",
      ],
      monthNamesShort: [
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic",
      ],
      today: "Hoy",
      clear: "Borrar",
    };

    this.auxitems = [...this.items];

    this.recuperarPosicion();
  }

  /**
   * Si el usuario no ha definido una funcion personalizada este descargara la tal cual está.
   */
  public exportCsv() {
    // Si el usuario ha definido una función personalizada para procesar los datos, simplemente los devuelve.
    // Si no, les aplica el proceso genérico para convertir a CSV: descargar la tabla tal cual está.

    const charset = "windows-1252";
    let csv: string =
      "data:text/csv;charset=" +
      charset +
      ",\ufeff" +
      (this.cols || []).map((it) => it.header).join(";") +
      "\n";

    (this.items || []).forEach((row) => {
      this.cols.forEach((col) => {
        let str = row[col.field];
        if ([undefined, "undefined", null, "null", NaN, "NaN"].includes(str)) {
          str = "";
        } else {
          try {
            if (typeof str == "number") {
              str = str.toString();
            } else {
              str = str.replace("#", "");
            }
          } catch (e) {
            str = "";
            console.log("error", e);
          }
        }
        csv += '"' + (str || "").replace(/"/g, '\\"') + '";';
        //csv += str + ';';
      });
      csv = csv.slice(0, -1) + "\n";
    });

    const csvLink = document.getElementById("csvLink") as HTMLAnchorElement;
    csvLink.download = "articulos" + "_exportado.csv";
    csvLink.href = encodeURI(csv);
    csvLink.click();
  }

  recuperarPosicion() {
    try {
      this.buscador = localStorage.getItem("buscador");
      this.buscadorEspecial(this.buscador);
      localStorage.removeItem("buscador");
    } catch (error) {
      this.buscador = "";
    }
    try {
      if (this.comprobarSiHayValorDefinido(localStorage.getItem("date"))) {
        this.date2 = new Date(localStorage.getItem("date"));
        this.filtrarFecha(this.date2, this.dt, "fecha");
        localStorage.removeItem("date");
      } else {
      }
    } catch (error) {
      this.date2 = null;
    }
    try {
      if (
        localStorage.getItem("guardar_posicion") !== null ||
        localStorage.getItem("guardar_posicion") !== undefined
      ) {
        this.first = Number(localStorage.getItem("guardar_posicion"));

        localStorage.removeItem("guardar_posicion");
      } else {
        this.first = 0;
      }
    } catch (error) {
      this.first = 0;
    }
  }

  listarCampos() {
    this.listarCamposEmmit.emit();
  }

  consultar(dt) {
    //console.log('dt', dt);

    this.consultarInformes.emit(dt);
  }

  filtartTexto(event, dt, col) {
    if (event == null || event == "" || event == undefined) {
      this.dt.filter(null, col, col.filterMatchMode);
    } else {
      let text = String(event);
      this.dt.filter(text, col, col.filterMatchMode);
    }
    this.cambios(dt);
  }

  filtrarFecha(event, dt, col) {
    if (event == null || event == "" || event == undefined) {
      this.dt.filter(null, col, col.filterMatchMode);
    } else {
      let myfecha = new Date(event);
      let mes = myfecha.getMonth() + 1;
      let mesCorregido = "";
      let dia = myfecha.getDate();
      let diaCorregido = "";
      if (mes < 10) {
        mesCorregido = "0" + mes;
      } else {
        mesCorregido = "" + mes;
      }
      if (dia < 10) {
        diaCorregido = "0" + dia;
      } else {
        diaCorregido = "" + dia;
      }

      let segmentarFEcha =
        diaCorregido + "/" + mesCorregido + "/" + myfecha.getFullYear();

      this.dt.filter(segmentarFEcha, col, col.filterMatchMode);
      //console.log('filtrar fecha', this.dt);
    }

    this.cambios(dt);
  }

  cambios(dt) {
    this.mydt = dt;
  }

  checkRole() {
    try {
      if (localStorage.getItem("role").localeCompare("ROLE_ADMIN") == 0) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  }

  checkRevisionTirita() {
    if (localStorage.getItem("role").localeCompare("ROLE_ADMIN") == 0) {
      return true;
    }
    let readonly = "";
    try {
      readonly = localStorage.getItem("readonly");
    } catch (error) {
      readonly = "";
    }
    if (readonly.localeCompare("1") == 0) {
      return false;
    } else {
      return true;
    }
  }

  changeValueRevision(data: any) {
    this.changeValueRevisionEmmit.emit(data);
  }

  changeValue(value, index) {
    let data = {
      value,
      index,
    };

    this.changeValueEmmit.emit(data);
  }

  info(event) {
    this.infoEmmit.emit(event);
  }

  iniciar() {
    this.iniciarEmmit.emit(true);
  }

  update(id, index) {
    if (this.comprobarSiHayValorDefinido(this.buscador)) {
      localStorage.setItem("buscador", this.buscador);
    }

    try {
      if (this.date2.toTimeString().length >= 1) {
        localStorage.setItem("date", this.date2.toUTCString());
      } else {
      }
    } catch (error) {}
    //console.log('this.dt.first.toString()',this.dt.first.toString());
    localStorage.setItem("guardar_posicion", this.dt.first.toString());
    this.router.navigate(["edit", id], { relativeTo: this.route });
    //this.updateEmmit.emit( event );
  }

  delete(id) {
    this.deleteEmmit.emit(id);
  }

  nuevo() {
    this.router.navigate(["crear"], { relativeTo: this.route });
  }

  duplicate($event: any): void {
    this.duplicateEmmit.emit($event);
  }

  buscadorEspecial(value: string) {
    this.items = [...this.auxitems];

    if (value == null || value == undefined || value.length <= 0) {
      this.items = [...this.auxitems];
    } else {
      if (value.includes(valorAnd)) {
        let valores = value.split(valorAnd);
        let items = [];
        for (let index = 0; index < valores.length; index++) {
          if (this.comprobarSiHayValorDefinido(valores[index])) {
            const element = valores[index];
            items = this.buscadorSimple(element);
            console.log("items", items);
            this.items = this.quitarDuplicados(items);
          }
        }
      } else if (value.includes(valorOr)) {
        let valores = value.split(valorOr);
        this.items = this.quitarDuplicados(this.buscadorCompuesto(valores));
      } else {
        let items = this.quitarDuplicados(this.buscadorSimple(value));
        this.items = items;
      }
    }

    //localStorage.setItem('dt',JSON.stringify(this.dt.);
    this.mydt = this.dt;
  }

  buscadorSimple(value: string) {
    let items = [];
    for (let index = 0; index < this.items.length; index++) {
      const element = this.items[index];
      for (const iterator in element) {
        if (this.comprobarSiHayValorDefinido(this.items[index][iterator])) {
          if (
            this.items[index][iterator]
              .toString()
              .toLowerCase()
              .normalize("NFD")
              .replace(new RegExp(/[\u0300-\u036f]/g), "")
              .includes(
                value
                  .toLocaleLowerCase()
                  .normalize("NFD")
                  .replace(new RegExp(/[\u0300-\u036f]/g), ""),
              )
          ) {
            items.push(this.items[index]);
          }
        }
      }
    }

    return items;
  }

  buscadorCompuesto(value: string[]) {
    let items = [];
    for (let index = 0; index < this.items.length; index++) {
      const element = this.items[index];
      for (const iterator in element) {
        if (this.comprobarSiHayValorDefinido(this.items[index][iterator])) {
          for (let index2 = 0; index2 < value.length; index2++) {
            const element2 = value[index2];
            if (this.comprobarSiHayValorDefinido(element2)) {
              if (
                (this.items[index][iterator] as string)
                  .toLowerCase()
                  .normalize("NFD")
                  .replace(new RegExp(/[\u0300-\u036f]/g), "")
                  .includes(
                    element2
                      .toLocaleLowerCase()
                      .normalize("NFD")
                      .replace(new RegExp(/[\u0300-\u036f]/g), ""),
                  )
              ) {
                items.push(this.items[index]);
              }
            }
          }
        }
      }
    }
    return items;
  }

  comprobarSiHayValorDefinido(value): boolean {
    if (value == null || value == undefined || value.length <= 0) {
      return false;
    } else {
      return true;
    }
  }

  quitarDuplicados(etiquetas: any[]) {
    let item = [];
    let discriminador = true;
    for (let index = 0; index < etiquetas.length; index++) {
      etiquetas[index].id;
      for (let index2 = 0; index2 < item.length; index2++) {
        if (item[index2].id == etiquetas[index].id) {
          discriminador = false;
        } else {
          discriminador = true;
        }
      }
      if (discriminador) {
        item.push(etiquetas[index]);
      } else {
        discriminador = true;
      }
    }
    return item;
  }

  comprobarFilaValor(columna: string, valor: string): string {
    try {
      if (this.fieldsOkNok != null && this.fieldsOkNok.length >= 1) {
        if (this.fieldsOkNok.includes(columna)) {
          if (valor == "1") {
            return "OK";
          } else {
            return "NOK";
          }
        }
      }
      if (this.camposOkNada != null && this.camposOkNada.length >= 1) {
        if (this.camposOkNada.includes(columna)) {
          if (valor == "1") {
            return "OK";
          } else {
            return "";
          }
        }
      }

      return this.cellValueTransform(columna, valor);
    } catch (error) {
      return valor;
    }
  }

  comprobarCalidad(data: any) {
    let result = new Array();
    let myRespuesta = "";
    /* global_gap
    IGP
    prod_integrado
    residuo */
    if (
      data.global_gap !== null &&
      data.global_gap !== undefined &&
      data.global_gap.localeCompare("1") == 0
    ) {
      result.push("Global gap");
    }
    if (
      data.IGP !== null &&
      data.IGP !== undefined &&
      data.IGP.localeCompare("1") == 0
    ) {
      result.push("IGP");
    }
    if (
      data.prod_integrado !== null &&
      data.prod_integrado !== undefined &&
      data.prod_integrado.localeCompare("1") == 0
    ) {
      result.push("Producción integrada");
    }
    if (
      data.residuo !== null &&
      data.residuo !== undefined &&
      data.residuo.localeCompare("1") == 0
    ) {
      result.push("Residuo 0");
    }

    if (result.length == 0) {
      return myRespuesta;
    } else {
      return (myRespuesta = result.toString());
    }
  }
  comprobarDiscriminador(value) {
    if (this.comprobarSiHayValorDefinido(this.discriminadorCampo)) {
      if (this.comprobarSiHayValorDefinido(value[this.discriminadorCampo])) {
        if (
          (value[this.discriminadorCampo] as string).localeCompare(
            "00/00/0000",
          ) == 0 ||
          (value[this.discriminadorCampo] as string).localeCompare(
            "00-00-0000",
          ) == 0
        ) {
          return true;
        }
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  comprobarNuevaDiferencia(value) {
    let resultado = "";
    try {
      resultado = JSON.parse(value);
    } catch (error) {}
    return resultado;
  }

  viewDocument(value): string {
    let url = "";
    if (this.urlCertificado != null && this.urlCertificado.length > 1) {
      try {
        if (value.length > 2) {
          url = this.urlCertificado + value;
        } else {
          url = "";
        }
      } catch (error) {
        url = "";
      }
    } else {
      try {
        if (value.length > 2) {
          url = this.url2 + value;
        } else {
          url = "";
        }
      } catch (error) {
        url = "";
      }
    }

    return url;
  }

  mostrarOperario() {
    this.mostrarOperarioEmmit.emit();
  }
  getDocumentCertificado(archivo) {
    return this.url2 + archivo;
  }

  verHigiene() {
    window.open(
      "https://www.traza-brio.com/calidad/ws/upload/encuesta_higiene/P.02%20Anexo%20V%20-%20Encuesta%20de%20Higiene%20-%20Rev.01%2015.01.19.docx",
      "_blank",
    );
  }

  checkRoleRead() {
    try {
      if (localStorage.getItem("readonly").localeCompare("1") == 0) {
        return false;
      }
    } catch (error) {}

    if (localStorage.getItem("role").localeCompare("ROLE_ADMIN") == 0) {
      return true;
    }
    if (localStorage.getItem("role").localeCompare("ROLE_USER") == 0) {
      return true;
    }
  }

  cuadernoCampoFiltrarVacios(event) {
    this.listarCuadernodeCampo.emit(event);
  }

  actualizarItems(items) {
    this.items = items;
    this.auxitems = items;
    this.buscadorEspecial(this.buscador);
  }

  customSort(event: SortEvent) {
    event.data.sort((data1, data2) => {
      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = null;

      if (value1 == null && value2 != null) result = -1;
      else if (value1 != null && value2 == null) result = 1;
      else if (value1 == null && value2 == null) result = 0;
      else if (typeof value1 === "string" && typeof value2 === "string")
        result = value1.localeCompare(value2);
      else result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;

      return event.order * result;
    });
  }

  isActive: any;
  items_: any;

  onFilter(event: PointerEvent) {
    if (this.isActive) {
      this.items_ = [...this.items];

      this.items = this.items.filter((item) => item.activo === "1");
    } else {
      this.items = [...this.items_];
    }
  }
}
